import de from '@/lang/de'
import en from '@/lang/en'

export default {
  de,
  en,
}
